function VehicleCleanRequestTransformer(Util, jsonMapper) {

	function transform(intermediateRequest, userInput) {
		delete intermediateRequest.vehicleForm;

		var vehicle = intermediateRequest.vehicles[0];
		var policyHolders = intermediateRequest.policyHolders;
		delete vehicle.paymentOptions ;
		delete vehicle.locationParked ;
		delete vehicle.primaryCarUse ;
		delete vehicle.businessActivityType ;
		delete vehicle.commercialActivityType ;
		delete vehicle.modifications ;
		delete vehicle.modificationsOptions ;
		delete vehicle.modificationsBuilt ;
		delete vehicle.modificationsBuiltOptions ;
		delete vehicle.carFinance ;
		delete vehicle.last12Months ;

		delete vehicle.vehicleInfo.averageKM;
		delete vehicle.vehicleInfo.cylinders;
		delete vehicle.vehicleInfo.description;
		delete vehicle.vehicleInfo.engineDescription;
		delete vehicle.vehicleInfo.goodKM;
		delete vehicle.vehicleInfo.goodRetailPrice;
		delete vehicle.vehicleInfo.imageUrls;
		delete vehicle.vehicleInfo.inductionDescription;
		delete vehicle.vehicleInfo.kerbWeight;
		delete vehicle.vehicleInfo.optionalEquipments;
		delete vehicle.vehicleInfo.power;
		delete vehicle.vehicleInfo.ratingGrade;
		delete vehicle.vehicleInfo.standardEquipments;
		delete vehicle.vehicleInfo.vehicleKey;
		delete vehicle.vehicleInfo.vin;


		if ( vehicle.drivers ) {
			vehicle.drivers.forEach(function(policyDriver) {
				delete policyDriver.driver._HTMLID;
				delete policyDriver.driver.$$hashKey;
				delete policyDriver.driver._aggregator;

				delete policyDriver.driver.maxNoClaimBonus;
				delete policyDriver.driver.title;
				delete policyDriver.driver.yearsHeld;
				delete policyDriver.driver.fourYears_chargedOrConvictedOffences;
				delete policyDriver.driver.fourYears_chargedOrConvictedOffencesDetails;
				delete policyDriver.driver.fourYears_licenceRSDC;
				delete policyDriver.driver.fourYears_licenceRSDCDetails;
				delete policyDriver.driver.fourYears_vehicleAccidentsClaims;
				delete policyDriver.driver.fourYears_vehicleAccidentsClaimsDetails;
				delete policyDriver.driver.tenYears_chargedOrConvictedOffences;
				delete policyDriver.driver.tenYears_chargedOrConvictedOffencesDetails;

				/**
				* Guidewire creates duplicate records of other drivers criminal histories
				* if the driverHistory is sent as an empty array :)
				* For now this has been commented out and moved to PublicIDTransformer as that
				* is creating an array when going through and transforming public ID's for a list.  This behaviour should be changed for empty lists.
				* After changing that, this can be commented back in and removed from publicIDTransformer.
				if ( policyDriver.driver.driverHistory
					&& Array.isArray(policyDriver.driver.driverHistory)
					&& policyDriver.driver.driverHistory.length == 0 )
					delete policyDriver.driver.driverHistory;
				*/
			})
		}

		if ( policyHolders ) {
			policyHolders.forEach(function(ph){			
			delete ph.contact._HTMLID;
			delete ph.contact.$$hashKey;
			delete ph.contact._aggregator;

			delete ph.contact.anyInfringements;
			delete ph.contact.anyLostLicences;
			delete ph.contact.mainPolicyHolder;
			delete ph.contact.isMainDriverMainPolicyHolder;

			delete ph.contact.policyContact;
			delete ph.contact.phoneNumber;
			delete ph.contact.postalOption;
			delete ph.contact.primaryPhoneNumber;
			delete ph.contact.title;
			delete ph.contact.address;

			delete ph.contact.fourYears_chargedOrConvictedOffences;
			delete ph.contact.fourYears_chargedOrConvictedOffencesDetails;
			delete ph.contact.fourYears_licenceRSDC;
			delete ph.contact.fourYears_licenceRSDCDetails;
			delete ph.contact.fourYears_vehicleAccidentsClaims;
			delete ph.contact.fourYears_vehicleAccidentsClaimsDetails;
			delete ph.contact.tenYears_chargedOrConvictedOffences;
			delete ph.contact.tenYears_chargedOrConvictedOffencesDetails;

			delete ph.contact.additionalPolicyHolderFourYears_chargedOrConvictedOffences;
			delete ph.contact.additionalPolicyHolderFourYears_chargedOrConvictedOffencesDetails;
			delete ph.contact.additionalPolicyHolderFourYears_licenceRSDC;
			delete ph.contact.additionalPolicyHolderFourYears_licenceRSDCDetails;
			delete ph.contact.additionalPolicyHolderFourYears_vehicleAccidentsClaims;
			delete ph.contact.additionalPolicyHolderFourYears_vehicleAccidentsClaimsDetails;
			delete ph.contact.additionalPolicyHolderTenYears_chargedOrConvictedOffences;
			delete ph.contact.additionalPolicyHolderTenYears_chargedOrConvictedOffencesDetails;
			})
		}



		if ( ! intermediateRequest.email )
			delete intermediateRequest.email ;

		return intermediateRequest;
	}

	return {
		transform: transform
	}
}
